var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 0.75C31.1245 0.75 31.8333 1.45889 31.8333 2.33333V27.6667C31.8333 28.5411 31.1245 29.25 30.25 29.25H1.75001C0.875562 29.25 0.166672 28.5411 0.166672 27.6667V2.33333C0.166672 1.45889 0.875562 0.75 1.75001 0.75H30.25ZM28.6667 13.4167H3.33334V26.0833H28.6667V13.4167ZM28.6667 3.91667H3.33334V10.25H28.6667V3.91667ZM14.4167 5.5V8.66667H11.25V5.5H14.4167ZM8.08334 5.5V8.66667H4.91667V5.5H8.08334Z",
    fill: "#0AC79A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.346db5f24506db612417784de3561f00.svg";
export { ForwardRef as ReactComponent };